var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ 'margin-top' : _vm.headerMargin ? '60px': '0'}),attrs:{"id":"layout-body"}},[_c('router-view'),_c('back-top')],1)}
var staticRenderFns = []

export { render, staticRenderFns }